import React, { useState, useEffect } from "react";
import { aboutBg, services11 } from "../../../../assets/images"; // Örnek görsel eklendi
import { useTranslation } from "react-i18next";
import SubOtherHero from "../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero";

const IpmIsm = () => {
  const { t } = useTranslation();

  const [heroHeight, setHeroHeight] = useState("300px");

  useEffect(() => {
    const updateHeight = () => {
      setHeroHeight(window.innerWidth < 640 ? "200px" : "300px");
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return (
    <>
      {/* Hero Section */}
      <div
        className="relative bg-black/60 w-full"
        style={{
          backgroundImage: `url(${aboutBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: heroHeight,
        }}
      >
        <SubOtherHero title="IPM, ISM" />
      </div>

      {/* Content Section */}
      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="max-w-containerSm md:max-w-container mx-auto md:flex md:items-start md:justify-between gap-10">
          {/* Left Content */}
          <div className="md:w-1/2">
            <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont">
              {t("IPM, ISM")}
            </p>

            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t(
                "Together with turn-key projects, Caspian Rock Solutions introduces a drilling rig and an algorithm for technical, technological, logistical and administrative solutions aimed at minimizing the risks of the customer not only during the construction of wells, but also during its further operation."
              )}
            </p>
            <p className="mt-6 text-[20px] font-semibold text-[#141615]">
              {t("Advantages of complex services:")}
            </p>
            <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
              <li>
                {t(
                  "Releases the customer from operational control over the work of contractors"
                )}
              </li>
              <li>
                {t(
                  "Acts as a “project manager” for managing complex or small projects"
                )}
              </li>
              <li>{t("Provides quality work execution")}</li>
              <li>{t("Saves time for the entire work cycle")}</li>
              <li>
                {t(
                  "Achieves the efficiency of the working processes of the oil company for account of compliance with international engineering standards"
                )}
              </li>
            </ul>
          </div>

          {/* Right Image */}
          <div className="mt-8 md:mt-0 md:w-1/2 ">
            <img
              src={services11}
              alt="Service Illustration"
              className="w-full rounded-lg shadow-md"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default IpmIsm;
